import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { IProps, IDispatchProps } from './interfaces';
import { IAssetStatus } from '../../../../api/vault/assetStatus/interfaces';
import { cancelJob, toggleRemoveJobs } from '../../../../state/jobStatus';
import { Notice, TableWrapper } from './styles';
import Button from '../../VaultButton';
import {
  DialogHeader,
  DialogHeaderTitle,
  DialogContentContainer,
  DialogActionsOverride,
  ActionContainer,
} from '../../styles/dialog';

interface HeadCell {
  id: keyof IAssetStatus;
  label: string;
}

const headCells: Array<HeadCell> = [
  { id: 'user', label: 'User' },
  { id: 'assetName', label: 'Asset' },
];

class RemoveJobs extends React.Component<IProps> {
  onBulkCancelJobs() {
    const { jobs, onJobCancel, onClose } = this.props;
    jobs.forEach((job) => onJobCancel(job._id));
    onClose();
  }

  render() {
    const { jobs, onClose } = this.props;

    return (
      <>
        <DialogHeader>
          <DialogHeaderTitle>
            Remove Jobs ({ jobs.length })
          </DialogHeaderTitle>
        </DialogHeader>
        <DialogContentContainer>
          <Notice>Are you sure you would like to cancel the following jobs?</Notice>
          <TableWrapper>
            <Table size="small">
              <TableHead>
                <TableRow>
                  {headCells.map((cell) => (
                    <TableCell
                      key={cell.id}
                      align="center"
                    >
                      {cell.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {jobs.map((job) => (
                  <TableRow>
                    <TableCell align="center">
                      {job.user}
                    </TableCell>
                    <TableCell align="center">
                      {job.assetName}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableWrapper>
        </DialogContentContainer>
        <DialogActionsOverride disableSpacing>
          <ActionContainer>
            <Button
              variant="plainOnPaper"
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              variant="primaryOnWhite"
              onClick={() => this.onBulkCancelJobs()}
            >
              Confirm
            </Button>
          </ActionContainer>
        </DialogActionsOverride>
      </>
    );
  }
}

const mapDispatchToProps: IDispatchProps = {
  onJobCancel: cancelJob,
  onClose: toggleRemoveJobs,
};

export default connect(
  null,
  mapDispatchToProps,
)(RemoveJobs);
